/* eslint-disable max-len */
import React from "react"
import Pagination from "../../../components/Pagination"

const OpeningStockTable = ({OpeningStockList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    OpeningStockCount}) => {
        
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, page_number: pageNum.selected + 1 });
    }

    return (
        <div className=" w-full relative">
            <div className="overflow-x-auto pb-2.5 scroll-bar -mx-[2px]">
                <div class={`flex px-[6px] ${OpeningStockCount > 50 ? 'max-h-[calc(100vh-268px)]' : 'max-h-[calc(100vh-228px)]'}`}>
                    <table aria-label="Outside Table" class="w-full relative stickyhead" id="admin-table">
                        <thead>
                            <tr>
                                <th className="w-[15%]">
                                    <span className="sticky top-0 flex items-center justify-start">Item Code</span>
                                </th>
                                <th className="w-[18%]">
                                    <span className="sticky top-0 flex items-center justify-start">Item Name</span>
                                </th>
                                <th className="w-[12%]">
                                    <span className="sticky top-0 flex items-center justify-end">Opening Stock Qty</span>
                                </th>
                                <th className="w-[12%]">
                                    <span className="sticky top-0 flex items-center justify-end">Opening Stock Value</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr aria-colspan="7" className="relative h-0.5 z-[-10]"></tr>
                            {OpeningStockList?.map((stock, index) => (
                                <React.Fragment key={index}>
                                    <tr aria-colspan="7" className="relative h-0.5 z-[-10]"></tr>
                                    <tr className="group">
                                        <td className="text-start" id={'item_code'+index}>{stock?.item_code || '-'}</td>
                                        <td className="text-start" id={'item_name'+index}>{stock?.item_name || '-'}</td>
                                        <td className="text-end" id={'opening_stock_quantity'+index}>{stock?.opening_stock_quantity || '-'}</td>
                                        <td className="text-end" id={'opening_stock_amount'+index}>{stock?.opening_stock_amount || '-'}</td>
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                        
                    </table>
                </div>
            </div>
            <div className="">
                {OpeningStockCount > 50 && <Pagination
                    TotalCount={OpeningStockCount}
                    limit={50}
                    totalPageNumber={Math.ceil(OpeningStockCount / 50)}
                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div>
        </div>
    );
}

export default OpeningStockTable;
